import { Link } from "react-router-dom"

import { SidebarBadge } from "components/badges/SidebarBadge"

import { NavLinkItem } from "./navConfig"

type Props = {
  item: NavLinkItem
  label: string
  collapsed: boolean
  badgeValue?: number
  onNavigate: () => void
  className: string
  iconClassName?: string
  showBadge?: boolean
}

export const SidebarLink = ({ item, label, collapsed, badgeValue, onNavigate, className, iconClassName, showBadge = true }: Props) => {
  const Icon = item.icon

  return (
    <Link to={item.url} onClick={onNavigate} className={className} title={collapsed ? label : undefined}>
      <div className="flex items-center justify-center">
        <Icon className={iconClassName ?? "w-[22px] h-[22px]"} />
      </div>

      {!collapsed && (
        <>
          <span className="flex-1">{label}</span>
          {showBadge && <SidebarBadge value={badgeValue} />}
        </>
      )}
    </Link>
  )
}
